import axios from "axios";
import HeaderInternal from "./parts/header-internal";
import Footer from "./parts/footer";
import React, {useEffect, useState} from "react";
import ProgramBase from "./program/program-base";
import {Accordion, AccordionItem} from "@szhsin/react-accordion";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import Form from "./forms/form";
import programImage from '../img/program_ac.jpg'
import {IoTicket} from "react-icons/io5";
import {Link} from "react-scroll";
import HuaweiImage from "../img/banner-huawei.jpg";
import Faq from "./faq/faq";
import { FaCheck } from "react-icons/fa";
import { TbBulb } from "react-icons/tb";
import { MdOutlineShoppingCart } from "react-icons/md";
import { LuHandshake } from "react-icons/lu";
import { PiStepsDuotone } from "react-icons/pi";
import FirstScreenBG from "../img/velnerolga_course.jpg";
import DOMPurify from "dompurify";

import ValeriaPilyuk from '../img/winners/Valeria_Pilyuk.webp';
import TetyanaHolovatska from '../img/winners/Tetyana_Holovatska.webp';
import MariaChitova from '../img/winners/Maria_Chitova.webp';


function Content(select_field) {
    return select_field.map((field, fieldIndex) => {
        console.log(field);

        switch (field.acf_fc_layout) {
            case "module_block":
                return (
                    <div key={fieldIndex}>
                        {Array.isArray(field.add_speech) &&
                            field.add_speech.map((moduleDetail, speakerIndex) => (
                                <div
                                    className="sm:grid grid-cols-3 gap-y-1 gap-x-3 px-3 py-6 border-b border-dashed"
                                    key={speakerIndex}
                                >
                                    <div className="speaker md:mb-0 flex flex-wrap items-start gap-3">
                                        <div className="w-[100px]">
                                            <div className="font-bold">
                                                {moduleDetail.date_speach}
                                            </div>
                                            <div>
                                                {moduleDetail.time_speach}
                                            </div>
                                        </div>

                                        <h3 className="w-[calc(100%-115px)]">
                                            {moduleDetail.solo_speach_theme}
                                        </h3>
                                    </div>

                                    <div className="col-span-2">
                                        {Array.isArray(moduleDetail.author_speach) &&
                                            moduleDetail.author_speach.map((author, index) => (
                                                <div
                                                    className="flex flex-wrap mb-5 max-sm:mt-3"
                                                    key={index}
                                                >
                                                    <div className="w-[100px] mr-[15px] relative overflow-hidden">
                                                        <img
                                                            className="relative z-20"
                                                            src={author.acf.sm_image}
                                                            alt={author.post_title}
                                                        />

                                                        <div className="absolute bottom-0 left-0 w-full h-full bg-[#AF00A9]/80 transform-gpu skew-x-[30deg] z-10" />
                                                    </div>

                                                    <div className="w-[calc(100%-115px)]">
                                                        <h3 className="text-[1.1em]">
                                                            {author.post_title}
                                                        </h3>
                                                        <p>{author.acf.position_short}</p>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    <div className="col-span-1" />

                                    <div
                                        className="w-full sm:pl-[115px] thesis-list col-span-3"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                moduleDetail.thesis_speach || '',
                                                { sanitize: true }
                                            )
                                        }}
                                    />
                                </div>
                            ))}
                    </div>
                );

            default:
                return null;
        }
    });
}


const winners = [
    {
        name: "Валерія Пилюк",
        company: 'Енергоаудиторська компанія "Teploria"',
        description:
        "Перша спеціалізована енергоаудиторська компанія у Харківському регіоні",
        image: ValeriaPilyuk,
    },
    {
        name: "Тетяна Головацька",
        company: "Retrokufer",
        description:
        "Етнокрамниця: автентичне вбрання, прикраси, декор",
        image: TetyanaHolovatska,
    },
    {
        name: "Марія Читова",
        company: "СІНО",
        description:
        "Перша онлайн платформа в Україні з продажу та генерування терапевтичних послуг",
        image: MariaChitova,
    },
];

function Course() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/2472?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf.program);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let programData = post

  //  console.log(programData)

    return (
        <>
            <HeaderInternal/>
            <section className="sm:py-40 py-20 mb-10 relative overflow-hidden" style={{
                background: 'url(' + FirstScreenBG + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundAttachment: 'fixed'
            }} id="top">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 overflow-hidden">
                        <div className="absolute left-0 top-0 sm:w-1/2 w-full h-full sm:z-10" style={{
                            backgroundImage: `url(${programImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}/>
                        <div></div>
                        <div className="sm:p-3 relative z-30 text-white">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                            <h1 className="sm:text-4xl text-3xl mb-3 uppercase">Практичний курс для запуску та розвитку
                                бізнесу</h1>
                            <p className="text-xl font-bold mb-4">Не дай загубитись своїй бізнес-ідеї!</p>
                            <p className="mb-4">Запусти або масштабуй свій онлайн-бізнес разом із практичним курсом «Від
                                ідеї до дії». Практичний курс, створений для жінок, які хочуть реалізувати свою ідею,
                                здобути знання та менторську підтримку для розвитку в підприємництві.</p>

                            <a href="/" className="mb-4 block">Від Women in Tech 2026: Створюй. Лідируй. Трансформуй в Україні</a>
                            <div className="grid sm:grid-cols-3 mb-4 text-sm">
                                <div
                                    className="relative sm:after:absolute after:block after:bottom-0 after:right-3 sm:after:h-full after:h-[10px] sm:after:w-[5px] after:w-full after:bg-[#AF00A9] after:transform-gpu after:skew-x-[-30deg] after:z-10">
                                    <span className="relative z-20">Подавай заявку до <br/><b>4 вересня 2026</b></span>
                                </div>
                                <div
                                    className="relative sm:after:absolute after:block after:bottom-0 after:right-3 sm:after:h-full after:h-[10px] sm:after:w-[5px] after:w-full after:bg-[#AF00A9] after:transform-gpu after:skew-x-[-30deg] after:z-10">
                                    <span className="relative z-20">Стартуємо <br/><b>8 вересня 2026</b></span></div>
                                <div>Пітчинг фіналістів <br/><b>29 жовтня 2026</b></div>
                            </div>

                            <div className="backdrop-blur pt-4 px-4 pb-8 bg-white overflow-hidden">
                                <p className="text-black">Подати заявку зараз</p>
                                <Form page="course"/>
                            </div>
                            </ScrollAnimation>
                        </div>

                    </div>
                </div>
                <div className="absolute left-0 top-0 w-full h-full bg-[#AF00A9]/85"/>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <h2 className="sm:text-4xl text-xl uppercase text-center mb-2">
                        <ScrollAnimation animateIn="animate__fadeInUp">Варто долучитись, якщо</ScrollAnimation></h2>

                    <div className="grid sm:grid-cols-2">
                        <ScrollAnimation animateIn="animate__fadeInUp" className="p-4">
                            <div className="flex flex-wrap">
                                <TbBulb className="w-[40px] mr-[15px] text-4xl"/>
                                <div className="w-[calc(100%-55px)]">
                                    Бажаєш сформулювати ідею, зібрати бізнес-план і підготуватись до залучення
                                    інвестицій
                                </div>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp" className="p-4">
                            <div className="flex flex-wrap">
                                <MdOutlineShoppingCart className="w-[40px] mr-[15px] text-4xl"/>
                                <div className="w-[calc(100%-55px)]">
                                    Прагнеш запустити бізнес в онлайні та потребуєш покрокового плану
                                    реалізації
                                </div>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp" className="p-4">
                            <div className="flex flex-wrap">
                                <LuHandshake className="w-[40px] mr-[15px] text-4xl"/>
                                <div className="w-[calc(100%-55px)]">
                                    Шукаєш інструменти, знання і зв’язки, які реально працюють у світі
                                    діджитал
                                </div>
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp" className="p-4">
                            <div className="flex flex-wrap">
                                <PiStepsDuotone className="w-[40px] mr-[15px] text-4xl"/>
                                <div className="w-[calc(100%-55px)]">
                                    Плануєш масштабувати і розвивати справу, навіть якщо стартуєш із нуля
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>

                </div>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <h2 className="sm:text-4xl text-xl uppercase text-center mb-6">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            Склад програми - 6 блоків практики, які повторюють реальний business flow
                        </ScrollAnimation>
                        </h2>

                    <Accordion allowMultiple transition transitionTimeout={250}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Продукт</h3></div>
                            } initialEntered>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Ти маєш ідею, але вона поки що — лише в голові?</em></p>
                                    <p className="mb-3">Цей блок допоможе тобі структурувати свої думки, визначити сильні і слабкі сторони проєкту, зрозуміти, у чому цінність твого продукту, кому він потрібен і як його подати.</p>
                                    <p><b>Ідеально, якщо ти: тільки починаєш, губишся в тому, як зібрати ідею докупи, або хочеш мати чіткий план запуску.</b></p>
                                </div>

                            </AccordionItem>

                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Ринок</h3></div>
                            } initialEntered>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Твоя ідея — супер, але кому вона дійсно цікава?</em></p>
                                    <p className="mb-3">Тут навчишся аналізувати конкурентів, розуміти, чого хоче твій потенційний клієнт, і як зробити так, щоб твій продукт не просто існував, а потрапляв «в точку»</p>
                                    <p><b>Підходить, якщо сумніваєшся, чи "зайде" ідея, або ще не маєш уявлення про свого клієнта.</b></p>
                                </div>

                            </AccordionItem>

                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Продажі</h3></div>
                            }>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Готова продавати, але не знаєш, з чого почати?</em></p>
                                    <p className="mb-3">Ми покажемо, як побудувати ефективну стратегію продажів, автоматизувати процеси й знайти канали, де на тебе вже чекають клієнти.</p>
                                    <p><b>Цей блок — для тих, хто боїться слова «продажі», або вже щось продає, але не стабільно.</b></p>
                                </div>
                            </AccordionItem>

                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Масштабування</h3></div>
                            }>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Вже стартувала, але що далі?</em></p>
                                    <p className="mb-3">Ти дізнаєшся, як зростати без хаосу, тестувати гіпотези, вибудовувати стратегію для виходу за межі України й створити мережу потрібних контактів.</p>
                                    <p><b>Якщо ти не хочеш «варитись у власному соку» та мрієш вийти на нові ринки — це твоє.</b></p>
                                </div>
                            </AccordionItem>

                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Фінанси</h3></div>
                            }>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Потрібні гроші, але страшно говорити з інвесторами?</em></p>
                                    <p className="mb-3">Навчимось готувати пітч, шукати інвесторів, розумітись на умовах угод і не погоджуватись на невигідне.</p>
                                    <p><b>Ідеально, якщо тобі потрібне фінансування або просто хочеш розібратись, як «працюють великі».</b></p>
                                </div>
                            </AccordionItem>

                            <AccordionItem className="mb-5 w-full" header={
                                <div className="bg-[#AF00A9]/85 p-2 text-white"><h3>Операційні процеси</h3></div>
                            }>
                                <div className="bg-[#AF00A9]/20 p-4">
                                    <p className="mb-3"><em>Настав час зібрати все до купи.</em></p>
                                    <p className="mb-3">ЯЯк оформити бізнес юридично, щоб не втратити контроль? Як захистити свою ідею? Як написати лист інвестору, щоб не залишитися без відповіді?</p>
                                    <p>Цей блок про те, як усе «завести» правильно, а також підготуватись до демо-дня, щоб справити враження.</p>
                                </div>
                            </AccordionItem>
                        </div>
                    </Accordion>

                </div>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <h2 className="sm:text-4xl text-xl uppercase text-center mb-6">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                        ЩО ТИ ОТРИМАЄШ ПІСЛЯ ПРОХОДЖЕННЯ ПРОГРАМИ?
                        </ScrollAnimation>
                        </h2>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Бізнес‑план і запуск</h3>
                                </div>
                            </div>
                            <p>Готовий проєкт із чіткою дорожньою картою запуску</p>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Грантова заявка</h3>
                                </div>
                            </div>

                            <p>Підготовлений опис для подачі на грант</p>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Ринок і ЦА</h3>
                                </div>
                            </div>

                            <p>Глибокий аналіз ринку та цільової аудиторії</p>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Практичні навички</h3>
                                </div>
                            </div>

                            <p>Продажі, маркетинг, PR, масштабування та фінансування</p>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Ментори й нетворкінг</h3>
                                </div>
                            </div>

                            <p>Підтримка експертів і нові бізнес‑контакти</p>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-wrap mb-3">
                                <FaCheck className="w-[30px] text-[#AF00A9]"/>
                                <div className="w-[calc(100%-45px)]">
                                    <h3>Pitch Day</h3>
                                </div>
                            </div>

                            <p>Презентація вашого проєкту на фіналі</p>
                        </ScrollAnimation>

                    </div>

                </div>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-center sm:mb-10 mb-5">
                        <div>
                            <img src={HuaweiImage} alt=""/>
                        </div>
                        <div>
                            <p className="sm:text-2xl text-xl max-w-80">
                                <ScrollAnimation animateIn="animate__fadeInUp">3 переможця отримають цінні подарунки від HUAWEI
                                    та можливості для подальшого розвитку власного бізнесу</ScrollAnimation>
                            </p>
                        </div>
                    </div>
                    <div className="text-center bg-[#AF00A9]/30 py-5 px-3 relative overflow-hidden">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                        <p className="mb-4">

                                <span className="font-bold text-xl">Готова діяти?</span><br/>Подай заявку, бо твоя ідея варта діла!

                        </p>
                        <Link to="top" spy={true}
                              smooth={true}
                              offset={-70}
                              duration={500}
                              className="font-normal uppercase py-2 px-4 inline-flex items-center bg-[#8C98FF]">
                            <IoTicket className="font-bold text-2xl mr-2"/>
                            <div>Взяти участь</div>
                        </Link>
                        </ScrollAnimation>
                        <div
                            className="absolute bottom-0 -right-[60px] w-[60px] h-full bg-white transform-gpu -skew-x-[30deg] z-20"/>
                    </div>
                </div>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">

                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2 className="sm:text-4xl text-xl uppercase text-center mb-2">Програма</h2>
                        <p className="text-center text-gray-600/60 mb-9">* Програма формується. Слідкуйте за
                            оновленнями</p>
                    </ScrollAnimation>
                    <Accordion allowMultiple transition transitionTimeout={250}>
                        {programData.map((item, index) => {
                            return item.acf.program_fields.map((layoutData, subIndex) => {
                                const {program_time, select_field} = layoutData
                                return (
                                    subIndex === 0 ?
                                        <AccordionItem className="mb-5 border border-1 w-full" key={subIndex} header={
                                            <div className="flex flex-wrap w-full">
                                                <div className="p-3 bg-[#8C98FF] w-[120px]">{program_time}</div>
                                                <div className="p-3 bg-[#8C98FF]/20 w-[calc(100%-120px)] text-left">
                                                    {select_field[0].theme_speech}
                                                </div>
                                            </div>
                                        } initialEntered>
                                            {Content(select_field)}
                                        </AccordionItem> :
                                        <AccordionItem className="mb-5 border border-1" key={subIndex} header={
                                            <div className="flex flex-wrap w-full">
                                                <div className="p-3 bg-[#8C98FF] w-[120px]">{program_time}</div>
                                                <div className="p-3 bg-[#8C98FF]/20 w-[calc(100%-120px)] text-left">
                                                    {select_field[0].theme_speech}
                                                </div>
                                            </div>
                                        }>
                                            {Content(select_field)}
                                        </AccordionItem>

                                );
                            });
                        })}
                    </Accordion>

                </div>
            </section>

            <section className="pb-10">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <h2 className="mb-4 sm:text-2xl text-xl">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                        Як оцінюється проєкт
                        </ScrollAnimation>
                        </h2>
                    <p className="mb-4">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                        Щоб кожна учасниця чітко знала, як здобути перемогу — ми впровадили прозору та справедливу систему оцінювання.
                        </ScrollAnimation>
                        </p>
                    <Accordion allowMultiple transition transitionTimeout={250}>
                        <AccordionItem className="mb-5 bg-[#AF00A9]/20 w-full p-4"
                                       header={<div className="text-left">5 ключових критеріїв</div>} initialEntered>
                            <div className="mt-4">
                                <p>Кожен проєкт оцінюється за п’ятьма важливими критеріями:</p>
                                <ul className="list-disc pl-4 pr-4">
                                    <li>
                                        <p><b>Ідея та інноваційність</b></p>
                                        <p>Чи вирішує бізнес актуальну проблему? Наскільки унікальне рішення? Чи має потенціал для масштабування та конкуренції?</p>
                                    </li>
                                    <li>
                                        <p><b>Бізнес-модель та фінансова життєздатність</b></p>
                                        <p>Чи зрозуміла бізнес-модель? Чи є чіткий план монетизації? Наскільки реалістичні фінансові прогнози?</p>
                                    </li>
                                    <li>
                                        <p><b>Розуміння ринку та клієнта</b></p>
                                        <p>Чи чітко визначена цільова аудиторія? Чи підтверджений попит? Чи зрозуміла стратегія виходу на ринок?</p>
                                    </li>
                                    <li>
                                        <p><b>Команда та реалізація</b></p>
                                        <p>Чи має команда достатню експертизу? Чи реалістичний план реалізації? Чи вистачає ресурсів для</p>
                                    </li>
                                    <li>
                                        <p><b>Презентація ідеї свого проєкту та пітч дей</b></p>
                                        <p>Наскільки чітко, логічно й впевнено подана інформація? Чи проєкт справляє
                                            враження на інвесторів і партнерів?
                                            Захист проєкту у форматі онлайн або офлайн виступу перед суддями та
                                            партнарами. Оцінюється, наскільки чітко, логічно та впевнено подана
                                            інформація і чи проєкт справляє враження та викликає зацікавлення.</p>
                                    </li>
                                </ul>
                            </div>
                        </AccordionItem>
                        <AccordionItem className="mb-5 bg-[#AF00A9]/20 p-4 w-full"
                                       header={<div className="text-left">Як ставляться бали</div>}>
                            <div className="mt-4">
                                <ul className="list-disc pl-4 pr-4">
                                    <li>У нас 5 членів журі.</li>
                                    <li>Кожен член журі оцінює кожен критерій за шкалою від 1 до 5 балів.</li>
                                    <li>Максимальний бал від одного журі — 25 балів (5 критеріїв × 5 балів).</li>
                                </ul>
                            </div>
                        </AccordionItem>
                        <AccordionItem className="mb-5 bg-[#AF00A9]/20 p-4 w-full"
                                       header={<div className="text-left">Як рахується фінальний бал</div>}>
                            <div className="mt-4">
                                <ul className="list-disc pl-4 pr-4">
                                    <li>Усі бали від усіх членів журі підсумовуються.</li>
                                    <li>Підраховується середній бал: загальна сума ділиться на кількість журі.</li>
                                    <li>Середній бал переводиться у відсотки для зручності: максимум 25 балів = 100%.
                                    </li>
                                </ul>
                            </div>
                        </AccordionItem>
                        <AccordionItem className="mb-5 bg-[#AF00A9]/20 p-4 w-full"
                                       header={<div className="text-left">Як обираємо переможця</div>}>
                            <div className="mt-4">
                                <ul className="mb-5">
                                    <li>Перемагає проєкт із найвищим середнім відсотком.</li>
                                    <li>Якщо кілька проєктів набирають однаковий бал — журі визначає переможця шляхом
                                        обговорення.
                                    </li>
                                </ul>

                                <h3 className="mb-4">Припустимо:</h3>
                                <ul className="list-disc pl-4 ml-4 mb-4">
                                    <li>Журі 1: 22 бали</li>
                                    <li>Журі 2: 20 балів</li>
                                    <li>Журі 3: 23 бали</li>
                                    <li>Журі 4: 19 балів</li>
                                    <li>Журі 5: 21 бал</li>
                                </ul>
                                <p className="mb-2"><b>Загальна сума:</b> 105</p>
                                <p className="mb-2"><b>Середній бал:</b> 105 ÷ 5 = 21</p>
                                <p className="mb-4"><b>Відсоток:</b> (21 ÷ 25) × 100% = 84%</p>
                                <p><b>Прозорі правила — чесна оцінка — рівні шанси для кожної ідеї!</b></p>
                            </div>
                        </AccordionItem>
                    </Accordion>
                </div>
            </section>

            

            <Faq/>

            <section className="relative mb-20">
                <div className="container max-w-screen-lg mx-auto px-5">
                    <h2 className="sm:text-4xl text-xl uppercase text-center mb-10">
                            Переможниці програми Women in Tech 2025
                    </h2>

                    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                    {winners.map((winner, index) => (
                        <div key={winner.name} className="relative flex min-h-[320px] flex-col bg-[#AF00A9]/30 p-6 pt-10 md:p-8
                            [clip-path:polygon(50px_0,100%_0,100%_calc(100%_-_50px),calc(100%_-_50px)_100%,0_100%,0_50px)]">
                            <div className="mb-4"><img src={winner.image} alt={winner.name}  className="w-full object-contain"/></div>

                            <h3 className="mb-3 text-2xl font-bold leading-tight md:text-3xl">
                                {winner.name}
                            </h3>

                            <p className="mb-4 text-lg font-semibold">
                                {winner.company}
                            </p>

                            <p className="text-base leading-[1.3] text-[#000]">
                                {winner.description}
                            </p>
                        </div>
                    ))}
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    )

}

export default Course;